import { ConfirmModal } from '@/components/ConfirmModal/ConfirmModal';

type ToggleBlockUserConfirmModalType = {
  isOpen: boolean;
  isBlockedUser: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ToggleBlockUserConfirmModal = ({
  isOpen,
  isBlockedUser,
  isLoading,
  onClose,
  onConfirm,
}: ToggleBlockUserConfirmModalType) => {
  const header = isBlockedUser ? 'Unblock User' : 'Block User';
  const body = isBlockedUser
    ? 'The user will regain access to WireVault and be able to perform their assigned functions within the organization.'
    : 'This User will no longer be able to access WireVault. You can choose to reset their account to reenable their access later.';

  return (
    <ConfirmModal
      isOpen={isOpen}
      isLoading={isLoading}
      header={header}
      body={body}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
